import "vite/modulepreload-polyfill";
import { createRoot } from "react-dom/client";
import { LatestProposalsWidget } from "./Components/LatestProposalsWidget.jsx";

export function RenderLatestProposals(configuration){
    const container = document.getElementById(configuration.container);
    const enableShareButtons = container.dataset.sharebuttons;
    const root = createRoot(container);

    root.render(
      (
        <LatestProposalsWidget configuration={configuration} />
      ),
    );
}

document.addEventListener("DOMContentLoaded", function() {
    const widget_configs = document.querySelectorAll(".latest-proposals-widget-config");

    for (let config of widget_configs) {
        RenderLatestProposals(JSON.parse(config.innerText));
    }
});
